(() => {
  const root = document.querySelector("#pageAbout");
  if (!root) return;

  const cdn = {
    gsap: "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js",
    scrollTrigger: "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js",
    flickity: "https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js",
    lenis: "https://cdn.jsdelivr.net/npm/lenis@1.1.20/dist/lenis.min.js"
  };

  const state = {
    headerHeight: 132,
    flickity: null
  };

  function loadScript(src, id) {
    return new Promise((resolve, reject) => {
      if (id && document.getElementById(id)) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.id = id || "";
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function measureHeader() {
    const header = document.querySelector(".header_new");
    const height = header ? Math.round(header.getBoundingClientRect().height) : 0;
    state.headerHeight = height || 132;
    root.style.setProperty("--pa-header-h", `${state.headerHeight}px`);
  }

  function initLenis(ScrollTrigger, gsap) {
    if (!window.Lenis || window.__pageAboutLenis) return;

    const lenis = new window.Lenis({
      duration: 1.5,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 1.5
    });

    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
    window.__pageAboutLenis = lenis;
  }

  function initCarousel() {
    const carousel = root.querySelector(".tricks-slider");
    if (!carousel || !window.Flickity) return;

    if (state.flickity) {
      state.flickity.destroy();
      state.flickity = null;
    }

    const mainSlides = ".tricks-slider_slide";
    const parallaxAmount = 49;
    const verticalAmount = 60;
    const rotationAmount = 6;

    const flkty = new window.Flickity(carousel, {
      freeScroll: true,
      percentPosition: true,
      pageDots: false,
      prevNextButtons: false,
      cellSelector: mainSlides,
      cellAlign: "center",
      wrapAround: true,
      resize: true,
      selectedAttraction: 0.01,
      dragThreshold: 1,
      freeScrollFriction: 0.05
    });

    const setImagePositions = () => {
      const carouselRect = carousel.getBoundingClientRect();
      const carouselWidth = carouselRect.width;
      const slides = carousel.querySelectorAll(mainSlides);

      slides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        const slideWidth = slideRect.width;

        let elementOffsetLeft = slideRect.left + slideWidth - carouselRect.left;
        let progressLeft = elementOffsetLeft / (carouselWidth + slideWidth);

        let elementOffsetCenter = slideRect.left + slideWidth / 2 - carouselWidth / 2;
        let parentWidth = carouselWidth + slideWidth;
        let progressCenter = elementOffsetCenter / parentWidth;

        let imageMoveDistance = parallaxAmount * progressLeft;

        if (imageMoveDistance > parallaxAmount) {
          imageMoveDistance = parallaxAmount;
        } else if (imageMoveDistance < 0) {
          imageMoveDistance = 0;
        }

        const image = slide.querySelector(".image-8");
        const wrap = slide.querySelector(".tricks-slider_wrap");

        if (image) {
          image.style.transform = `translateX(-${imageMoveDistance}%)`;
        }

        if (wrap) {
          wrap.style.transform = `translateY(${verticalAmount * progressCenter}%) rotate(${rotationAmount * progressCenter}deg)`;
        }
      });
    };

    flkty.on("scroll", setImagePositions);
    flkty.on("dragMove", setImagePositions);
    flkty.on("settle", setImagePositions);
    flkty.on("resize", setImagePositions);

    requestAnimationFrame(() => {
      flkty.resize();
      setImagePositions();
    });

    state.flickity = flkty;
  }

  function initAnimations() {
    measureHeader();

    if (!window.gsap || !window.ScrollTrigger) return;

    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);

    /* ==============================
   COLOR SCROLL
   ============================== */

function initColorScroll() {
  const colorThemes = {
1: {
  "--color--background": "#d8e9c0",
  "--color--text": "#7a6047",
  "--button--text": "#7a6047"
},
2: {
  "--color--background": "#ffffff",
  "--color--text": "#6f7a55",
  "--button--text": "#ffffff"
}
  };

  const heroBackground = root.querySelector(".header83-image-background");
  const sliderSection = root.querySelector(".section-slider");
  const block2 = root.querySelector(".section_header80");

  if (heroBackground && !heroBackground.hasAttribute("animate-body-to")) {
    heroBackground.setAttribute("animate-body-to", "2");
  }

  if (sliderSection && !sliderSection.hasAttribute("animate-body-to")) {
    sliderSection.setAttribute("animate-body-to", "2");
  }

  if (block2 && !block2.hasAttribute("animate-body-to")) {
    block2.setAttribute("animate-body-to", "1");
  }

  const triggerElements = root.querySelectorAll("[animate-body-to]");

  triggerElements.forEach((element, index) => {
    const modeIndex = Number(element.getAttribute("animate-body-to"));
    const targetTheme = colorThemes[modeIndex];

    if (!targetTheme) return;

    let endSetting = "clamp(bottom 35%)";

    if (index === triggerElements.length - 1) {
      endSetting = "bottom 35%";
    }

    gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "clamp(top 35%)",
        end: endSetting,
        toggleActions: "play complete none reverse"
      }
    }).to(root, {
      ...targetTheme,
      duration: 0.4,
      ease: "power1.out"
    });
  });
}

initColorScroll();

    initLenis(ScrollTrigger, gsap);

    ScrollTrigger.addEventListener("refreshInit", measureHeader);
function initBlock2TextSwap() {
  const title = root.querySelector("[data-pa-block2-switch]");
  const firstText = root.querySelector("[data-pa-block2-first]");
  const secondText = root.querySelector("[data-pa-block2-second]");
  const component = root.querySelector("[data-pa-header80]");

  if (!title || !firstText || !secondText || !component) return;

  gsap.set(title, {
    autoAlpha: 1
  });

  gsap.set(firstText, {
    clearProps: "all"
  });

  gsap.set(secondText, {
    clearProps: "all"
  });

  let currentState = "";

  function showFirst() {
    if (currentState === "first") return;

    firstText.hidden = false;
    secondText.hidden = true;
    currentState = "first";
  }

  function showSecond() {
    if (currentState === "second") return;

    firstText.hidden = true;
    secondText.hidden = false;
    currentState = "second";
  }

  showFirst();

  ScrollTrigger.create({
    trigger: component,
    start: "top top",
    end: "bottom bottom",
    invalidateOnRefresh: true,
    onUpdate: (self) => {
      if (self.progress < 0.6) {
        showFirst();
      } else {
        showSecond();
      }
    },
    onLeaveBack: showFirst,
    onEnter: showFirst
  });
}

function initBlock3BackgroundScroll() {
  const section = root.querySelector(".section_header80");
  const component = root.querySelector("[data-pa-header80]");

  if (!section || !component) return;

  gsap.set(section, {
    "--pa-block3-bg": "#f7f4ef",
    "--pa-block3-text": "#111111"
  });

  gsap.timeline({
    scrollTrigger: {
      trigger: component,
      start: "top top",
      end: "bottom bottom",
      scrub: true,
      invalidateOnRefresh: true
    }
  })
    .to(section, {
      "--pa-block3-bg": "#f4dedc",
      "--pa-block3-text": "#111111",
      duration: 0.52,
      ease: "none"
    })
    .to(section, {
      "--pa-block3-bg": "#e8edf4",
      "--pa-block3-text": "#111111",
      duration: 0.48,
      ease: "none"
    });
}

function initBlock3Words() {
  const component = root.querySelector("[data-pa-header80]");
  const words = gsap.utils.toArray(root.querySelectorAll("[data-pa-block3-word]"));

  if (!component || !words.length) return;

  let currentIndex = -1;
  let isAllActive = false;

  function setActiveWord(activeIndex) {
    if (currentIndex === activeIndex && !isAllActive) return;

    isAllActive = false;
    currentIndex = activeIndex;

    words.forEach((word, index) => {
      word.classList.toggle("is-active", index === activeIndex);
    });

    gsap.to(words, {
      opacity: (index) => (index === activeIndex ? 1 : 0.28),
      y: (index) => (index === activeIndex ? 0 : 12),
      duration: 0.28,
      ease: "power1.out",
      overwrite: true
    });
  }

  function setAllActive() {
    if (isAllActive) return;

    isAllActive = true;
    currentIndex = -1;

    words.forEach((word) => {
      word.classList.add("is-active");
    });

    gsap.to(words, {
      opacity: 1,
      y: 0,
      duration: 0.32,
      stagger: 0.04,
      ease: "power1.out",
      overwrite: true
    });
  }

  setActiveWord(0);

  ScrollTrigger.create({
    trigger: component,
    start: "top top",
    end: "bottom bottom",
    scrub: true,
    invalidateOnRefresh: true,
    onUpdate: (self) => {
      if (self.progress > 0.88) {
        setAllActive();
        return;
      }

      const activeIndex = Math.min(words.length - 1, Math.floor(self.progress * words.length));
      setActiveWord(activeIndex);
    },
    onLeaveBack: () => setActiveWord(0)
  });
}

function initBlock4() {
  const section = root.querySelector("[data-pa-block4]");

  if (!section) return;

  const imageWrap = section.querySelector("[data-pa-block4-image]");
  const image = section.querySelector(".block4_image");
  const copy = section.querySelector("[data-pa-block4-copy]");
  const copyItems = copy ? copy.children : [];

  if (imageWrap) {
    gsap.fromTo(
      imageWrap,
      {
        autoAlpha: 0,
        y: 46
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 72%",
          toggleActions: "play none none reverse"
        }
      }
    );
  }

  if (image) {
    gsap.fromTo(
      image,
      {
        scale: 1.06
      },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.8
        }
      }
    );
  }

  if (copyItems.length) {
    gsap.fromTo(
      copyItems,
      {
        autoAlpha: 0,
        y: 28
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.12,
        ease: "power2.out",
        scrollTrigger: {
          trigger: copy,
          start: "top 78%",
          toggleActions: "play none none reverse"
        }
      }
    );
  }
}

function initBlock5Manifesto() {
  const section = root.querySelector("[data-pa-block5]");

  if (!section) return;

  const inner = section.querySelector(".block5_inner");
  const eyebrow = section.querySelector("[data-pa-block5-eyebrow]");
  const lines = gsap.utils.toArray(section.querySelectorAll("[data-pa-block5-line]"));
  const emphasis = section.querySelector("[data-pa-block5-emphasis]");
  const pieces = gsap.utils.toArray(section.querySelectorAll("[data-pa-block5-piece]"));
  const revealItems = [eyebrow, ...lines, emphasis].filter(Boolean);

  if (!revealItems.length) return;

  gsap.set(revealItems, {
    visibility: "visible"
  });

  gsap.set(eyebrow, {
    autoAlpha: 0,
    y: 18
  });

  gsap.set(lines, {
    autoAlpha: 0,
    y: 54,
    clipPath: "inset(100% 0% 0% 0%)"
  });

  gsap.set(emphasis, {
    autoAlpha: 0,
    y: 42,
    scale: 0.96,
    textShadow: "0 0 0 rgba(242, 184, 210, 0)"
  });

  if (inner) {
    gsap.set(inner, {
      y: 0,
      scale: 1,
      autoAlpha: 1
    });
  }

  if (pieces.length) {
    gsap.set(pieces, {
      xPercent: -50,
      x: 0,
      y: "24vh",
      rotation: 0,
      scale: 0.72,
      autoAlpha: 0
    });
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: () => `top top+=${state.headerHeight}`,
      end: "bottom bottom",
      scrub: 0.9,
      invalidateOnRefresh: true
    }
  });

  tl.to(
    eyebrow,
    {
      autoAlpha: 0.72,
      y: 0,
      duration: 0.12,
      ease: "power2.out"
    },
    0
  )
    .to(
      lines,
      {
        autoAlpha: 1,
        y: 0,
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.26,
        stagger: 0.045,
        ease: "power3.out"
      },
      0.06
    )
    .to(
      emphasis,
      {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        duration: 0.22,
        ease: "power3.out"
      },
      0.28
    )
    .to(
      lines,
      {
        autoAlpha: 0.62,
        scale: 0.992,
        duration: 0.22,
        ease: "none"
      },
      0.52
    )
    .to(
      emphasis,
      {
        scale: 1.035,
        color: "#f6bfd7",
        textShadow: "0 0 34px rgba(242, 184, 210, 0.18)",
        duration: 0.24,
        ease: "none"
      },
      0.54
    );

  if (pieces.length) {
    tl.to(
      pieces,
      {
        autoAlpha: (index) => {
          const piece = pieces[index];

          if (piece.classList.contains("is-pink")) return 0.68;
          if (piece.classList.contains("is-bright")) return 0.58;

          return 0.38;
        },
        x: (index) => `${Number(pieces[index].getAttribute("data-x") || 0)}vw`,
        y: (index) => `${Number(pieces[index].getAttribute("data-y") || 0)}vh`,
        rotation: (index) => Number(pieces[index].getAttribute("data-rotate") || 0),
        scale: (index) => Number(pieces[index].getAttribute("data-scale") || 1),
        duration: 0.42,
        stagger: 0.022,
        ease: "none"
      },
      0.42
    )
      .to(
        pieces,
        {
          y: "-=6vh",
          autoAlpha: (index) => {
            const piece = pieces[index];

            if (piece.classList.contains("is-pink")) return 0.52;
            if (piece.classList.contains("is-bright")) return 0.44;

            return 0.28;
          },
          duration: 0.18,
          ease: "none"
        },
        0.84
      );
  }

  tl.to(
    inner,
    {
      autoAlpha: 0.98,
      scale: 1,
      duration: 0.16,
      ease: "none"
    },
    0.86
  );
}

function initEditorialIntro() {
  const section = root.querySelector("[data-pa-editorial]");

  if (!section) return;

  const left = section.querySelector("[data-pa-editorial-left]");
  const leftInner = section.querySelector("[data-pa-editorial-left-inner]");
  const body = section.querySelector("[data-pa-editorial-body]");
  const words = gsap.utils.toArray(section.querySelectorAll("[data-pa-editorial-word]"));
  const panels = gsap.utils.toArray(section.querySelectorAll("[data-pa-editorial-panel]"));

  if (left) {
    gsap.set(left, {
      visibility: "visible"
    });
  }

  if (leftInner) {
    gsap.set(leftInner, {
      clearProps: "transform"
    });
  }

  if (body) {
    gsap.set(body, {
      visibility: "visible"
    });
  }

  if (!words.length || !panels.length) return;

  const firstPanel = panels[0];
  const lastPanel = section.querySelector(".editorial-intro_panel--closing") || panels[panels.length - 1];

  function getPinTop() {
    return state.headerHeight + 80;
  }

  function getIntroHoldDistance() {
    return Math.round(window.innerHeight * 0.32);
  }

  function getLayoutTop(element) {
    let top = 0;
    let node = element;

    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }

    return top;
  }

  function getContentBottomWithinPanel(panel) {
    const children = Array.from(panel.children).filter((child) => {
      const style = window.getComputedStyle(child);
      return style.display !== "none" && style.visibility !== "hidden";
    });

    if (!children.length) return panel.offsetHeight;

    return Math.max(
      ...children.map((child) => child.offsetTop + child.offsetHeight)
    );
  }

  ScrollTrigger.create({
    trigger: firstPanel,
    start: () => `top top+=${getPinTop()}`,
    end: () => `+=${getIntroHoldDistance()}`,
    pin: firstPanel,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    refreshPriority: 2
  });

  ScrollTrigger.create({
    trigger: leftInner,
    start: () => `top top+=${getPinTop()}`,
    end: () => {
      const pinTop = getPinTop();
      const leftBottom = pinTop + leftInner.offsetHeight;
      const startScroll = getLayoutTop(leftInner) - pinTop;
      const rightContentBottom = getLayoutTop(lastPanel) + getContentBottomWithinPanel(lastPanel);
      const endScroll = rightContentBottom - leftBottom;

      return `+=${Math.max(1, endScroll - startScroll)}`;
    },
    pin: leftInner,
    pinSpacing: false,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    refreshPriority: 1
  });

  function setActiveWord(activeIndex) {
    words.forEach((word, index) => {
      word.classList.toggle("is-active", index === activeIndex);
    });

    gsap.to(words, {
      opacity: (index) => (index === activeIndex ? 1 : 0.22),
      x: (index) => (index === activeIndex ? 8 : 0),
      duration: 0.28,
      ease: "power1.out",
      overwrite: true
    });
  }

function setActivePanel(activePanel) {
  panels.forEach((panel) => {
    const isActive = panel === activePanel;

    gsap.to(panel, {
      autoAlpha: isActive ? 1 : 0.28,
      y: isActive ? 0 : 28,
      duration: 0.32,
      ease: "power1.out",
      overwrite: true
    });
  });
}

gsap.set(panels, {
  autoAlpha: 0.28,
  y: 28
});

gsap.set(panels[0], {
  autoAlpha: 1,
  y: 0
});

setActiveWord(0);

function updateEditorialFocus() {
  const viewportTarget = state.headerHeight + (window.innerHeight - state.headerHeight) * 0.5;
  let closestPanel = panels[0];
  let closestTargetIndex = Number(panels[0].getAttribute("data-pa-editorial-target") || 0);
  let closestDistance = Infinity;

  panels.forEach((panel) => {
    const rect = panel.getBoundingClientRect();
    const panelCenter = rect.top + rect.height * 0.5;
    const distance = Math.abs(panelCenter - viewportTarget);
    const targetIndex = Number(panel.getAttribute("data-pa-editorial-target") || 0);

    if (distance < closestDistance) {
      closestDistance = distance;
      closestPanel = panel;
      closestTargetIndex = targetIndex;
    }
  });

  setActiveWord(closestTargetIndex);
  setActivePanel(closestPanel);
}

ScrollTrigger.create({
  trigger: section,
  start: "top bottom",
  end: "bottom top",
  invalidateOnRefresh: true,
  onEnter: updateEditorialFocus,
  onEnterBack: updateEditorialFocus,
  onUpdate: updateEditorialFocus,
  onRefresh: updateEditorialFocus
});
}

    /* ==============================
       BLOCK 1
       ============================== */

    gsap.set(root.querySelectorAll("[data-pa-hero-title], [data-pa-scroll-text], [data-pa-logo-wrap]"), {
      visibility: "visible"
    });

    gsap.fromTo(
      root.querySelector("[data-pa-hero-title]"),
      {
        opacity: 0,
        y: 30
      },
      {
        opacity: 1,
        y: 0,
        delay: 0.8,
        duration: 1,
        ease: "power3.out"
      }
    );

    const scrollText = root.querySelector("[data-pa-scroll-text]");
    const scrollTextSpan = scrollText ? scrollText.querySelector("span") : null;

    if (scrollTextSpan) {
      gsap.set(scrollText, { visibility: "visible", opacity: 1 });
      gsap.fromTo(
        scrollTextSpan,
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, delay: 1.15, duration: 0.6, ease: "power2.out" }
      );
    }

const par = root.querySelector("[data-pa-par]");
const parLines = par ? par.querySelectorAll(".line") : [];

if (par && parLines.length) {
  gsap.set(par, {
    visibility: "visible",
    opacity: 1
  });

  gsap.set(parLines, {
    visibility: "visible",
    opacity: 1,
    x: 0,
    y: 0,
    scaleY: 1,
    rotation: 0,
    scale: 1,
    clearProps: "transform"
  });
}

    const logoWrap = root.querySelector("[data-pa-logo-wrap]");

    if (logoWrap) {
      gsap.fromTo(
        logoWrap,
        { opacity: 0 },
        {
          opacity: 1,
          delay: 0.35,
          duration: 0.6,
          ease: "power1.out",
          scrollTrigger: {
            trigger: logoWrap,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }

    gsap.utils.toArray(root.querySelectorAll(".tricks-slider_slide[data-gsap='img.1']")).forEach((slide) => {
      gsap.set(slide, { visibility: "visible" });
      gsap.fromTo(
        slide,
        {
          opacity: 0,
          clipPath: "inset(50% 50% 50% 50%)"
        },
        {
          opacity: 1,
          clipPath: "inset(0% 0% 0% 0%)",
          duration: 1.5,
          ease: "power1.out",
          scrollTrigger: {
            trigger: slide,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    initCarousel();

    /* ==============================
       BLOCK 2
       ============================== */

    gsap.utils.toArray(root.querySelectorAll(".header80_image-wrapper[data-gsap='img.4']")).forEach((item) => {
      gsap.set(item, { visibility: "visible" });
      gsap.fromTo(
        item,
        {
          opacity: 0,
          clipPath: "inset(0% 50% 0% 50%)"
        },
        {
          opacity: item.classList.contains("is-image-5") || item.classList.contains("is-image-6") ? 0.75 : 1,
          clipPath: "inset(0% 0% 0% 0%)",
          duration: 1,
          ease: "power1.out",
          scrollTrigger: {
            trigger: item,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    const title = root.querySelector("[data-pa-txt]");

    if (title) {
      gsap.set(title, {
        visibility: "visible",
        opacity: 0,
        y: 30,
        x: 0,
        rotation: 0,
        skewX: 0,
        skewY: 0,
        scale: 0.5,
        filter: "blur(100px)"
      });

      gsap.to(title, {
        opacity: 1,
        y: 0,
        x: 0,
        rotation: 0,
        skewX: 0,
        skewY: 0,
        scale: 1,
        filter: "blur(0px)",
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: title,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    }

    ScrollTrigger.matchMedia({
      "(min-width: 768px)": () => {
        gsap.fromTo(
          root.querySelector("[data-pa-h80-left]"),
          { yPercent: 0 },
          {
            yPercent: -85,
            ease: "none",
            scrollTrigger: {
              trigger: root.querySelector("[data-pa-h80-trigger]"),
              start: "top bottom",
              end: "bottom bottom",
              scrub: 0.9
            }
          }
        );

        gsap.fromTo(
          root.querySelector("[data-pa-h80-right]"),
          { yPercent: 0 },
          {
            yPercent: -60,
            ease: "none",
            scrollTrigger: {
              trigger: root.querySelector("[data-pa-h80-trigger]"),
              start: "top bottom",
              end: "bottom bottom",
              scrub: 0.9
            }
          }
        );
      },

      "(max-width: 767px)": () => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: root.querySelector("[data-pa-h80-trigger]"),
            start: "top bottom",
            end: "bottom bottom",
            scrub: 0.9
          }
        });

        tl.to(
          root.querySelectorAll("[data-pa-h80-left], [data-pa-h80-right]"),
          {
            yPercent: -85,
            ease: "none",
            duration: 65
          },
          0
        ).to({}, { duration: 35 });
      }
    });

initBlock2TextSwap();
initBlock3BackgroundScroll();
initBlock3Words();
initBlock4();
initBlock5Manifesto();

    /* ==============================
       NEXT BLOCK INSERT POINT
       ============================== */

    window.addEventListener("load", () => {
      measureHeader();
      if (state.flickity) state.flickity.resize();
      ScrollTrigger.refresh();
    });

    window.addEventListener("resize", () => {
      measureHeader();
      if (state.flickity) state.flickity.resize();
      ScrollTrigger.refresh();
    });
  }

  Promise.resolve()
    .then(() => loadScript(cdn.gsap, "pa-gsap"))
    .then(() => loadScript(cdn.scrollTrigger, "pa-scroll-trigger"))
    .then(() => loadScript(cdn.flickity, "pa-flickity"))
    .then(() => loadScript(cdn.lenis, "pa-lenis").catch(() => null))
    .then(initAnimations)
    .catch(() => {
      measureHeader();
    });
})();
